module.exports = __webpack_public_path__ + "img/calendar.ca45c061.svg";